import { AppBar, Badge, Hidden, Toolbar, Typography } from "@material-ui/core";
import {
  Input,
  Menu as MenuIcon,
  NotificationsOutlined as NotificationsIcon,
  Settings as SettingsIcon
} from "@mui/icons-material";//@material-ui/icons";
import { makeStyles } from "@material-ui/styles";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link as RouterLink } from "react-router-dom";
import { signOutRequest } from "src/features/authSlice";
import EnhancedIconButton from "src/components/enhanced/EnhancedIconButton";
import Settings from "src/components/Settings";
import { getSessionCompanyName, getSessionRooms } from "src/helpers/sessionHelper";
import { useHistory } from "react-router-dom";

function Topbar(props) {
  const { onSidebarOpen } = props;

  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  const onSignOut = () => {
    dispatch(signOutRequest(history));
  };

  const [openSettings, setOpenSettings] = useState(false);
  useEffect(() => {
    //if (Object.keys(getSessionRooms()).length === 0) setOpenSettings(true);
    setOpenSettings(true);
  }, []);

  const headerLabel = getSessionCompanyName();

  return (
    <AppBar className={classes.root}>
      <Toolbar>
        <RouterLink to="/" className={classes.title}>
          <Typography variant="h1" component="h2" gutterBottom className={classes.title}>
            {headerLabel}
          </Typography>
        </RouterLink>
        <div className={classes.flexGrow} />
        <Hidden mdDown>
          <EnhancedIconButton
            ariaLabel="notifications"
            tooltip="Oznámení"
            color="inherit"
            Icon={() => (
              <Badge badgeContent={0} color="primary" variant="dot">
                <NotificationsIcon />
              </Badge>
            )}
            onClick={() => {}}
          />
        </Hidden>
        <Hidden lgUp>
          <EnhancedIconButton ariaLabel="menu" tooltip="Menu" color="inherit" Icon={MenuIcon} onClick={onSidebarOpen} />
        </Hidden>
        <EnhancedIconButton
          ariaLabel="settings"
          tooltip="Nastavení"
          color="inherit"
          Icon={SettingsIcon}
          onClick={() => setOpenSettings(true)}
        />
        <EnhancedIconButton ariaLabel="logout" tooltip="Odhlásit" color="inherit" Icon={Input} onClick={onSignOut} />
      </Toolbar>
      <Settings openSettings={openSettings} setOpenSettings={setOpenSettings} />
    </AppBar>
  );
}

Topbar.propTypes = {
  className: PropTypes.string,
  onSidebarOpen: PropTypes.func
};

const useStyles = makeStyles((theme) => ({
  root: {
    boxShadow: "none"
  },
  flexGrow: {
    flexGrow: 1
  },
  signOutButton: {
    marginLeft: theme.spacing(1)
  },
  title: {
    color: "white",
    textDecoration: "none"
  }
}));

export default Topbar;
